<nb-card class="note-modal">
  <nb-card-header>مغایرت گیری</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-12">
        <nb-card style="max-height:500px"  class="mb-0 overflow-auto h-full" accent="success">
          <nb-card-header>مغایرت های موجود</nb-card-header>
          <nb-card-body>
            <div class="mb-3">
              <table class="table table-bordered text-center">
                <thead>
                <tr>
                  <th>نام ارز</th>
                  <th>مقدار مغایرت</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of allContradiction">
                  <td>
                    <div class="d-flex align-items-center gap-2 justify-content-center">
                      <img width="30" src="{{data.iconPath}}" alt="">
                      <span>{{data.name}}</span>
                      <span> ({{data.id}})</span>
                    </div>
                  </td>
                  <td>
                    <span class="text-align-left"
                      [class]="data.contradiction > 0 ? 'text-success' : 'text-danger'">{{data.contradiction | number: '1.0-3'}}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <button nbButton hero status="control" (click)="closeDialog()">بستن
            </button>

          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </nb-card-body>
</nb-card>
